import React from "react";

const Footer = () => (
  <footer style={styles.footer}>
    <span style={styles.text}>© {new Date().getFullYear()} Party Sharing — Promoter Panel</span>
    <span style={styles.version}>v1.0.0</span>
  </footer>
);

const styles = {
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 24px",
    background: "#1e1e2d",
    borderTop: "1px solid rgba(255,255,255,0.06)",
    flexShrink: 0,
  },
  text: {
    fontSize: 12,
    color: "#6b7280",
  },
  version: {
    fontSize: 11,
    color: "#4b5563",
  },
};

export default Footer;
